// packages/react/src/components/AppRoutes.tsx
// Switch renderer for the IVW-2.0 app-shell (ported for IVW-1.0 app.js parity).

import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ROUTES, DEFAULT_ROUTES } from './util/RouteConstants';

/**
 * AppRoutes — renders the app-shell `<Switch>` from the data-driven route table.
 *
 * Children are emitted in order:
 *  1. One exact-match `<Route>` + `<Redirect>` per DEFAULT_ROUTES entry (redirects first).
 *  2. One `<Route>` per ROUTES entry, applying `exact` only when RouteConfig.exact === true.
 *
 * Each element carries a unique React `key` equal to its path. Relies on `<Switch>`
 * first-match semantics: an unmatched location renders nothing (no catch-all/404), mirroring v1.
 */
const AppRoutes: React.FC = () => (
  <Switch>
    {Object.keys(DEFAULT_ROUTES).map((path) => (
      <Route exact path={path} key={path}>
        <Redirect to={DEFAULT_ROUTES[path]} />
      </Route>
    ))}
    {ROUTES.map((r) => (
      <Route
        path={r.path}
        key={r.path}
        component={r.component}
        exact={r.exact === true}
      />
    ))}
  </Switch>
);

export default AppRoutes;
